import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import LandingStyleHeader from "./components/LandingStyleHeader";
import Main from "./pages/Main";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import default styles

import "./App.css";
import Login from "./components/Login";
import Signup from "./components/Signup";
import { Dashboard } from "./components/Dashboard";
import QRCodeGenerator from "./components/Content";
import { AdminDashboard } from "./pages/adminDashboard";
import LandingPage from "./pages/LandingPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactusPage from "./pages/ContactUsPage";
import TestimonialPage from "./pages/TestimonialPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import ServicesPage from "./pages/ServicesPage";
import ProfilePage from "./pages/ProfilePage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import { getQrTagFromLocation } from "./shared/qrLinks";

const App = () => {
  const location = useLocation();
  const publicQrTag = getQrTagFromLocation(location);
  const isPublicQrView = Boolean(publicQrTag);
  const fullBleedRoutes = ["/", "/landing", "/login", "/signup", "/dashboard", "/content", "/profile"];
  const landingHeaderRoutes = [
    "/about-us",
    "/services",
    "/contact-us",
    "/testimonials",
    "/how-it-works",
    "/terms-of-service",
    "/privacy-policy",
  ];
  const hasPageOwnedChrome = fullBleedRoutes.includes(location.pathname) || isPublicQrView;
  const useLandingStyleHeader = !isPublicQrView && landingHeaderRoutes.includes(location.pathname);
  const [isScrolling, setIsScrolling] = useState(false);


  useEffect(() => {
    if (isPublicQrView) {
      document.body.style.backgroundColor = "white"; // or any other color you want to set when userId is present
    } else {
      document.body.style.backgroundColor = "rgb(12, 12, 12)";
    }

    return () => {
      document.body.style.backgroundColor = "rgb(12, 12, 12)";
    };
  }, [isPublicQrView]);


  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);
      clearTimeout(window.scrollTimeout);
      window.scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, 2000); // Hide footer after 1 second of no scrolling
    };

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <div className="app-container">
      {useLandingStyleHeader ? (
        <LandingStyleHeader />
      ) : (
        !isPublicQrView && !hasPageOwnedChrome && <Header />
      )}
      <ToastContainer />
      <div className="app-routes-container">
        {/* <Sidebar /> */}
        <Routes>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Main />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact-us" element={<ContactusPage />} />
          <Route path="/testimonials" element={<TestimonialPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          {/* /m removed; main app now lives at "/" */}
          <Route path="/signup" element={<Signup />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/content" element={<QRCodeGenerator />} />
          <Route path="/:qrTag" element={<Main />} />
        </Routes>
      </div>
      {/* {!userId && !hasPageOwnedChrome && (location.pathname !== "/" || isScrolling) && <Footer />} */}
    </div>
  );
};

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
